export const AssociationStatus = Object.freeze({
  "1": {label: 'linked', value: 1, className: "font-bold text-xl text-green-500"},
  "-1": {label: 'pending', value: -1, className: "font-bold text-xl text-gray-500"},
  "-2": {label: 'rejected', value: -2, className: "font-bold text-xl text-red-500"}
});

export const OrgType2Association = Object.freeze({
  "300": {value: "parish", label: 'parish', enabled: true},
  "302": {value: "diocese", label: 'diocese', enabled: true},
  "400": {value: "religious_order", label: 'religious orders', enabled: true},
  "100": {value: "undefined", label: 'organization'},
  "102": {value: "undefined", label: 'community'},
  "104": {value: "undefined", label: 'school'},
  "999": {value: "undefined", label: 'group'},
});

